<template>
  <Dialog
    v-model="dialogVisible"
    title="Vital & Measurements"
    dialog-type="primary"
    dialog-size="small"
    :close-on-overlay="false"
    @close="closeDialog"
  >
    <template #header-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M21.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0ZM21.3333 21.3333H19.0267L21.3333 19.0267V21.3333ZM21.3333 17.3333H20.2L16.2 21.3333H14.04L18.04 17.3333H15.2133L11.2133 21.3333H9.06667L13.0667 17.3333H10.24L6.24 21.3333H3.78667L7.78667 17.3333H4.96L2.66667 19.6267V2.66667H21.3333V17.3333Z" fill="white"/>
        <path d="M10.2267 10.6667L12.8933 13.3333L19.6667 6.54667L17.7867 4.66667L12.8933 9.56L10.2267 6.89333L4.33333 12.7867L6.21333 14.6667L10.2267 10.6667Z" fill="white"/>
      </svg>
    </template>

    <div class="health-info-body">
      <div class="form-sections">

        <!-- Section 1: Vital - Measurements -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6ZM11 9.5H10V8.5H11V9.5ZM12.5 9.5H11.5V8.5H12.5V9.5ZM14 9.5H13V8.5H14V9.5Z" fill="#004879"/>
              </svg>
            </div>
            <span class="section-title">Vital - Measurements</span>
          </div>
          <div class="form-grid">
            <div class="form-field">
              <label class="field-label">Height (in)</label>
              <TextInput
                v-model="formData.height"
                size="medium"
                :clearable="false"
                placeholder="e.g. 68"
                @blur="onFieldBlur('height')"
              />
              <span v-if="errors.height && touched.height" class="field-error">{{ errors.height }}</span>
            </div>
            <div class="form-field">
              <label class="field-label">Weight (lb)</label>
              <TextInput
                v-model="formData.weight"
                size="medium"
                :clearable="false"
                placeholder="e.g. 170"
                @blur="onFieldBlur('weight')"
              />
              <span v-if="errors.weight && touched.weight" class="field-error">{{ errors.weight }}</span>
            </div>
          </div>
        </div>

        <!-- Section 2: Vital - Heart Rate -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 20 18" fill="none">
                <path d="M10 18C9.7 18 9.4125 17.9458 9.1375 17.8375C8.8625 17.7292 8.61667 17.5667 8.4 17.35L1.7 10.625C1.11667 10.0417 0.6875 9.375 0.4125 8.625C0.1375 7.875 0 7.09167 0 6.275C0 4.55833 0.558333 3.08333 1.675 1.85C2.79167 0.616667 4.18333 0 5.85 0C6.65 0 7.40417 0.158333 8.1125 0.475C8.82083 0.791667 9.45 1.23333 10 1.8C10.5333 1.23333 11.1542 0.791667 11.8625 0.475C12.5708 0.158333 13.325 0 14.125 0C15.7917 0 17.1875 0.616667 18.3125 1.85C19.4375 3.08333 20 4.55 20 6.25C20 7.06667 19.8583 7.85 19.575 8.6C19.2917 9.35 18.8667 10.0167 18.3 10.6L11.575 17.35C11.3583 17.5667 11.1167 17.7292 10.85 17.8375C10.5833 17.9458 10.3 18 10 18ZM11 5C11.1667 5 11.325 5.04167 11.475 5.125C11.625 5.20833 11.7417 5.31667 11.825 5.45L13.525 8H17.675C17.7917 7.71667 17.8792 7.42917 17.9375 7.1375C17.9958 6.84583 18.025 6.55 18.025 6.25C17.9917 5.1 17.6083 4.1125 16.875 3.2875C16.1417 2.4625 15.225 2.05 14.125 2.05C13.6083 2.05 13.1125 2.15 12.6375 2.35C12.1625 2.55 11.75 2.84167 11.4 3.225L10.725 3.95C10.6417 4.05 10.5333 4.12917 10.4 4.1875C10.2667 4.24583 10.1333 4.275 10 4.275C9.86667 4.275 9.73333 4.24583 9.6 4.1875C9.46667 4.12917 9.35 4.05 9.25 3.95L8.575 3.225C8.225 2.84167 7.81667 2.54167 7.35 2.325C6.88333 2.10833 6.38333 2 5.85 2C4.75 2 3.83333 2.42083 3.1 3.2625C2.36667 4.10417 2 5.1 2 6.25C2 6.55 2.025 6.84583 2.075 7.1375C2.125 7.42917 2.20833 7.71667 2.325 8H7C7.16667 8 7.325 8.04167 7.475 8.125C7.625 8.20833 7.74167 8.31667 7.825 8.45L8.7 9.75L10.05 5.7C10.1167 5.5 10.2375 5.33333 10.4125 5.2C10.5875 5.06667 10.7833 5 11 5ZM11.3 8.25L9.95 12.3C9.88333 12.5 9.75833 12.6667 9.575 12.8C9.39167 12.9333 9.19167 13 8.975 13C8.80833 13 8.65 12.9583 8.5 12.875C8.35 12.7917 8.23333 12.6833 8.15 12.55L6.45 10H3.9L9.825 15.925C9.85833 15.9583 9.8875 15.9792 9.9125 15.9875C9.9375 15.9958 9.96667 16 10 16C10.0333 16 10.0625 15.9958 10.0875 15.9875C10.1125 15.9792 10.1417 15.9583 10.175 15.925L16.075 10H13C12.8333 10 12.675 9.95833 12.525 9.875C12.375 9.79167 12.25 9.68333 12.15 9.55L11.3 8.25Z" fill="#004879"/>
              </svg>
            </div>
            <span class="section-title">Vital - Heart Rate</span>
          </div>
          <div class="form-grid">
            <div class="form-field">
              <label class="field-label">Heart Rate (bpm)</label>
              <TextInput
                v-model="formData.heartRate"
                size="medium"
                :clearable="false"
                placeholder="e.g. 72 bpm"
                @blur="onFieldBlur('heartRate')"
              />
              <span v-if="errors.heartRate && touched.heartRate" class="field-error">{{ errors.heartRate }}</span>
            </div>
          </div>
        </div>

        <!-- Section 3: Vital - Temperature -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 11V5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V6H12V7H13V9H12V10H13V11H11Z" fill="#004879"/>
              </svg>
            </div>
            <span class="section-title">Vital - Temperature</span>
          </div>
          <div class="form-grid">
            <div class="form-field">
              <label class="field-label">Temperature (°F)</label>
              <TextInput
                v-model="formData.temperature"
                size="medium"
                :clearable="false"
                placeholder="e.g. 98.6"
                @blur="onFieldBlur('temperature')"
              />
              <span v-if="errors.temperature && touched.temperature" class="field-error">{{ errors.temperature }}</span>
            </div>
            <div class="form-field">
              <label class="field-label">Respiratory Rate (breaths/min)</label>
              <TextInput
                v-model="formData.respiratoryRate"
                size="medium"
                :clearable="false"
                placeholder="e.g. 52"
                @blur="onFieldBlur('respiratoryRate')"
              />
              <span v-if="errors.respiratoryRate && touched.respiratoryRate" class="field-error">{{ errors.respiratoryRate }}</span>
            </div>
          </div>
        </div>

        <!-- Section 4: Vital - Blood Condition -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 16 20" fill="none">
                <path d="M13.66 5.65L8 0L2.34 5.65C0.78 7.21 0 9.29 0 11.29C0 13.29 0.78 15.4 2.34 16.96C3.9 18.52 5.95 19.31 8 19.31C10.05 19.31 12.1 18.52 13.66 16.96C15.22 15.4 16 13.29 16 11.29C16 9.29 15.22 7.21 13.66 5.65ZM2 11.65C2.01 9.65 2.62 8.38 3.76 7.25L8 2.92L12.24 7.3C13.38 8.42 13.99 9.65 14 11.65H2Z" fill="#004879"/>
              </svg>
            </div>
            <span class="section-title">Vital - Blood Condition</span>
          </div>
          <div class="form-field mb-2">
            <label class="field-label">Blood Pressure</label>
          </div>
          <div class="form-grid">
            <div class="form-field">
              <label class="field-label">Systolic (mmHg)</label>
              <TextInput
                v-model="formData.systolic"
                size="medium"
                :clearable="false"
                placeholder="Systolic"
                @blur="onFieldBlur('systolic')"
              />
              <span v-if="errors.systolic && touched.systolic" class="field-error">{{ errors.systolic }}</span>
            </div>
            <div class="form-field">
              <label class="field-label">Diastolic (mmHg)</label>
              <TextInput
                v-model="formData.diastolic"
                size="medium"
                :clearable="false"
                placeholder="Diastolic"
                @blur="onFieldBlur('diastolic')"
              />
              <span v-if="errors.diastolic && touched.diastolic" class="field-error">{{ errors.diastolic }}</span>
            </div>
          </div>
          <div class="form-grid mt-2">
            <div class="form-field">
              <label class="field-label">Oxygen Saturation (%)</label>
              <TextInput
                v-model="formData.oxygenSaturation"
                size="medium"
                :clearable="false"
                placeholder="e.g. 98"
                @blur="onFieldBlur('oxygenSaturation')"
              />
              <span v-if="errors.oxygenSaturation && touched.oxygenSaturation" class="field-error">{{ errors.oxygenSaturation }}</span>
            </div>
          </div>
        </div>

        <!-- Section 5: Vital - Pain Level -->
        <div class="form-section form-section-last">
          <div class="section-header">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 16 20" fill="none">
                <path d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM14.39 10.56C12.71 9.7 10.53 9 8 9C5.47 9 3.29 9.7 1.61 10.56C0.61 11.07 0 12.1 0 13.22V20H2V13.22C2 12.84 2.2 12.5 2.52 12.34C3.71 11.73 5.63 11 8 11C8.76 11 9.47 11.07 10.13 11.2L8.58 14.5H5.75C4.23 14.5 3 15.73 3 17.25C3 18.77 4.23 20 5.75 20H14C15.1 20 16 19.1 16 18V13.22C16 12.1 15.39 11.07 14.39 10.56ZM6.94 18H5.75C5.34 18 5 17.66 5 17.25C5 16.84 5.34 16.5 5.75 16.5H7.64L6.94 18ZM14 18H9.15L12.09 11.73C12.63 11.93 13.1 12.14 13.49 12.34C13.8 12.5 14 12.84 14 13.22V18Z" fill="#004879"/>
              </svg>
            </div>
            <span class="section-title">Vital - Pain Level</span>
          </div>
          <div class="form-field">
            <label class="field-label">Pain Level (0-10)</label>
            <TextInput
              v-model="formData.painLevel"
              size="medium"
              :clearable="false"
              placeholder="0"
              @blur="onFieldBlur('painLevel')"
            />
            <span v-if="errors.painLevel && touched.painLevel" class="field-error">{{ errors.painLevel }}</span>
          </div>
          <div class="form-field mt-2">
            <label class="field-label">Cause of Pain</label>
            <div class="textarea-wrapper">
              <el-input
                v-model="formData.causeOfPain"
                type="textarea"
                placeholder="Systolic"
                :rows="3"
                :maxlength="1000"
                class="health-form-textarea"
                resize="none"
              />
              <div class="textarea-footer">
                <span class="char-count">{{ (formData.causeOfPain || '').length }}/1000 characters</span>
                <span class="clear-btn" @click="formData.causeOfPain = ''">Clear</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Dialog Footer -->
    <template #footer>
      <ResponsiveButton
        display_name="Cancel"
        button_type="outlined"
        built_in_theme="error"
        size="medium"
        @click-button="closeDialog"
      />
      <ResponsiveButton
        display_name="Update"
        button_type="filled"
        built_in_theme="dark"
        size="medium"
        :disabled="hasValidationErrors || isSaving"
        @click-button="saveHealthInfo"
      />
    </template>
  </Dialog>
</template>

<script>
import { notify } from '@/utils/notify';
import { createVitalEntry, getRecentVitals, transformVitalsToHealthInfo } from '@/api/vitalsApi';

export default {
  name: 'HealthInfoDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    patientInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        height: '',
        weight: '',
        heartRate: '',
        temperature: '',
        respiratoryRate: '',
        systolic: '',
        diastolic: '',
        oxygenSaturation: '',
        painLevel: '',
        causeOfPain: ''
      },
      errors: {
        height: '',
        weight: '',
        heartRate: '',
        temperature: '',
        respiratoryRate: '',
        systolic: '',
        diastolic: '',
        oxygenSaturation: '',
        painLevel: '',
        causeOfPain: ''
      },
      touched: {
        height: false,
        weight: false,
        heartRate: false,
        temperature: false,
        respiratoryRate: false,
        systolic: false,
        diastolic: false,
        oxygenSaturation: false,
        painLevel: false,
        causeOfPain: false
      },
      isSaving: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    },
    hasValidationErrors() {
      return Object.values(this.errors).some(e => e !== '');
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
    formData: {
      deep: true,
      handler() {
        for (const field of Object.keys(this.touched)) {
          if (this.touched[field]) {
            this.validateField(field);
          }
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    async saveHealthInfo() {
      if (this.isSaving) return;
      this.isSaving = true;
      const patientId = this.patientInfo?.patientBasicInfo?.patientId ||
                        this.patientInfo?.patientId ||
                        this.patientInfo?.id ||
                        this.patientInfo?.patientBasicInfo?.id;

      if (!patientId) {
        notify({
          title: 'Error',
          message: 'Patient ID is required',
          type: 'error',
          duration: 3000
        });
        return;
      }

      // Validate numeric fields
      const validationError = this.validateFields();
      if (validationError) {
        notify({
          title: 'Validation Error',
          message: validationError,
          type: 'warning',
          duration: 3000
        });
        return;
      }

      try {
        const fieldToVital = [
          { field: 'height', vital_type: 'Ht', unit: 'in' },
          { field: 'weight', vital_type: 'Wt', unit: 'lbs' },
          { field: 'heartRate', vital_type: 'HR', unit: 'bpm' },
          { field: 'temperature', vital_type: 'Temp', unit: '°F' },
          { field: 'respiratoryRate', vital_type: 'RR', unit: 'breaths/min' },
          { field: 'oxygenSaturation', vital_type: 'SpO2', unit: '%' },
          { field: 'painLevel', vital_type: 'Pain', unit: 'scale' },
        ];

        const timestamp = new Date().toISOString();
        const createPromises = [];

        for (const mapping of fieldToVital) {
          const val = this.formData[mapping.field];
          if (val !== '' && val !== null && val !== undefined) {
            let notes = mapping.notes || '';
            // For Pain, use causeOfPain as notes
            if (mapping.field === 'painLevel' && this.formData.causeOfPain) {
              notes = this.formData.causeOfPain;
            }
            createPromises.push(
              createVitalEntry({
                patient_id: patientId,
                vital_type: mapping.vital_type,
                value: val,
                unit: mapping.unit,
                source: 'manual',
                notes,
                timestamp
              })
            );
          }
        }

        // BP: merge systolic/diastolic into one request with "systolic/diastolic" format
        const systolicVal = this.formData.systolic;
        const diastolicVal = this.formData.diastolic;
        const hasSystolic = systolicVal !== '' && systolicVal !== null && systolicVal !== undefined;
        const hasDiastolic = diastolicVal !== '' && diastolicVal !== null && diastolicVal !== undefined;
        if (hasSystolic || hasDiastolic) {
          const s = hasSystolic ? systolicVal : 0;
          const d = hasDiastolic ? diastolicVal : 0;
          createPromises.push(
            createVitalEntry({
              patient_id: patientId,
              vital_type: 'BP',
              value: `${s}/${d}`,
              unit: 'mmHg',
              source: 'manual',
              notes: '',
              timestamp
            })
          );
        }

        if (createPromises.length > 0) {
          await Promise.all(createPromises);
        }

        // Refresh vitals from API to get auto-computed BMI and latest data
        const response = await getRecentVitals(patientId);
        const healthInfo = transformVitalsToHealthInfo(response.entries);
        this.$store.commit('myPatients/patientInfo/SET_CURRENT_PATIENT_HEALTH_INFO', healthInfo);

        this.$emit('save', healthInfo);
        this.resetForm();
        this.$emit('close');
      } catch (error) {
        console.error('Failed to save health info:', error);
        notify({
          title: 'Error',
          message: 'Failed to Save Health Information',
          type: 'error',
          duration: 3000
        });
      } finally {
        this.isSaving = false;
      }
    },
    getValidationRules() {
      return {
        height: { label: 'Height (in)', type: 'numeric', min: 0.1, max: 120 },
        weight: { label: 'Weight (lb)', type: 'numeric', min: 0.1, max: 1500 },
        heartRate: { label: 'Heart Rate', type: 'numeric', min: 20, max: 300 },
        temperature: { label: 'Temperature (°F)', type: 'numeric', min: 50, max: 115 },
        respiratoryRate: { label: 'Respiratory Rate', type: 'numeric', min: 4, max: 60 },
        systolic: { label: 'Systolic', type: 'integer', min: 40, max: 300 },
        diastolic: { label: 'Diastolic', type: 'integer', min: 20, max: 200 },
        oxygenSaturation: { label: 'Oxygen Saturation', type: 'numeric', min: 50, max: 100 },
        painLevel: { label: 'Pain Level', type: 'integer', min: 0, max: 10 },
      };
    },
    validateField(fieldName) {
      const rules = this.getValidationRules();
      const rule = rules[fieldName];
      const val = this.formData[fieldName];

      // Skip fields without rules (e.g. causeOfPain)
      if (!rule) {
        this.errors[fieldName] = '';
        return;
      }

      // All fields are optional - only validate if non-empty
      if (val === '' || val === null || val === undefined) {
        this.errors[fieldName] = '';
        return;
      }

      // Custom validator (height)
      if (rule.validate) {
        this.errors[fieldName] = rule.validate(val) || '';
        return;
      }

      const num = parseFloat(val);

      if (isNaN(num)) {
        this.errors[fieldName] = `${rule.label} must be a valid number`;
        return;
      }

      if (rule.type === 'integer' && !Number.isInteger(Number(val))) {
        this.errors[fieldName] = `${rule.label} must be a whole number`;
        return;
      }

      if (num < rule.min || num > rule.max) {
        this.errors[fieldName] = `Must be between ${rule.min} and ${rule.max}`;
        return;
      }

      this.errors[fieldName] = '';
    },
    onFieldBlur(fieldName) {
      this.touched[fieldName] = true;
      this.validateField(fieldName);
    },
    validateFields() {
      for (const field of Object.keys(this.formData)) {
        this.touched[field] = true;
        this.validateField(field);
      }
      const firstError = Object.entries(this.errors).find(([, msg]) => msg !== '');
      return firstError ? firstError[1] : null;
    },
    resetForm() {
      this.formData = {
        height: '',
        weight: '',
        heartRate: '',
        temperature: '',
        respiratoryRate: '',
        systolic: '',
        diastolic: '',
        oxygenSaturation: '',
        painLevel: '',
        causeOfPain: ''
      };
      this.errors = {
        height: '',
        weight: '',
        heartRate: '',
        temperature: '',
        respiratoryRate: '',
        systolic: '',
        diastolic: '',
        oxygenSaturation: '',
        painLevel: '',
        causeOfPain: ''
      };
      this.touched = {
        height: false,
        weight: false,
        heartRate: false,
        temperature: false,
        respiratoryRate: false,
        systolic: false,
        diastolic: false,
        oxygenSaturation: false,
        painLevel: false,
        causeOfPain: false
      };
    }
  }
};
</script>

<style scoped>
.health-info-body {
  padding-top: 24px;
  padding-bottom: 8px;
}

/* Form sections container */
.form-sections {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Each section with dashed bottom border */
.form-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px dashed var(--DividerGray, #C4C4C4);
}

.form-section-last {
  border-bottom: none;
  padding-bottom: 0;
}

/* Section header with icon + title */
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  width: 24px;
  height: 24px;
  background: #F2F2F2;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.section-title {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 20px;
  letter-spacing: 0.1px;
}

/* Two column grid layout */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  overflow: hidden;
  color: var(--color-Grey-Grey-4A, #4A4A4A);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.mt-2 {
  margin-top: 8px;
}

.mb-2 {
  margin-bottom: 4px;
}

/* Textarea wrapper with footer */
.textarea-wrapper {
  position: relative;
}

.textarea-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.char-count {
  font-family: Inter;
  font-size: 12px;
  color: #999;
}

.clear-btn {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  color: #1E4670;
  text-decoration: underline;
  cursor: pointer;
}

.clear-btn:hover {
  color: #004879;
}

/* Error message text below field */
.field-error {
  font-family: Inter;
  font-size: 12px;
  color: #F56C6C;
  line-height: 16px;
  margin-top: 2px;
}

/* Red border on inputs with errors */
:deep(.has-error .el-input__wrapper) {
  border: 1px solid #F56C6C !important;
}

:deep(.has-error .el-input__wrapper:hover),
:deep(.has-error .el-input__wrapper:focus),
:deep(.has-error .el-input__wrapper.is-focus) {
  border: 1px solid #F56C6C !important;
}

/* Form inputs */
:deep(.el-input .el-input__wrapper) {
  border: 1px solid #C9C9C9 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  height: 40px !important;
}

:deep(.el-input .el-input__wrapper:hover),
:deep(.el-input .el-input__wrapper:focus),
:deep(.el-input .el-input__wrapper.is-focus) {
  border: 1px solid #C9C9C9 !important;
  box-shadow: none !important;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #F5F5F5 !important;
  cursor: not-allowed;
}

/* Textarea inputs */
:deep(.el-textarea .el-textarea__inner) {
  border: 1px solid #C9C9C9 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  font-family: Inter;
  font-size: 14px;
}

:deep(.el-textarea .el-textarea__inner:hover),
:deep(.el-textarea .el-textarea__inner:focus) {
  border: 1px solid #C9C9C9 !important;
  box-shadow: none !important;
}

/* Placeholder styling */
:deep(.health-form-input .el-input__inner::placeholder),
:deep(.health-form-textarea .el-textarea__inner::placeholder) {
  font-size: 14px !important;
  color: #999 !important;
}
</style>
